import React, { ReactElement, useMemo, FC } from 'react'
import PropTypes from 'prop-types'
import { Popover, Button, Space, Skeleton} from 'antd'

import { Container, Header, LeftHeader, Title, SubTitle, Body, ActionButtons, Description } from './styles';
import { DatabaseOutlined } from '@ant-design/icons'
import { FormattedMessage, useIntl } from 'react-intl';

import PanelMenu from './PanelMenu'
import { FormattedMessageFixed } from 'utils';

export interface FormPanelProps {
    title?: string,
    subtitle?: string,
    theme?: string
    onClick?: (id:string)=>{},
    desc?: string,
    content?: [],
    actions?: [],
    controls?: [],
    flat?: boolean,
    queryId?: string,
    style?: object,
    loading?: boolean,
    layout?: 'vertical' | 'horizontal'
}

const FormPanel:FC<FormPanelProps> = function ({title, theme = 'default', subtitle, actions, desc, children, controls, style, queryId, loading=false, onClick, layout='horizontal',flat=false}) {
    const intl = useIntl()
    const _title = useMemo(()=>{
        try{
            return intl.formatMessage({id:title});
        }catch(e){
            return title;
        }
    },[title])

    const _desc = useMemo(()=>{
        if(!desc) return;
        var t = intl.formatMessage({id:desc});
        return t;
    },[desc])

    return (
        <Container style={{...style}} className={theme}>
            <Header>
                <LeftHeader>
                    <Title>{_title || title}</Title>
                    {subtitle && <SubTitle>{subtitle}</SubTitle>}
                </LeftHeader>
                <Space>
                  {controls && controls.map(control=>{
                    var { id, icon , component, title, _onClick } = control
                    if(icon){
                        return <Button size="small" icon={icon} onClick={()=> { (_onClick && _onClick()); onClick(id) } }>{title}</Button>
                    }else if(component){
                        return component;
                    }
                  })}
                  {actions && <ActionButtons>
                      <PanelMenu actions={actions} />
                  </ActionButtons>}
                  {queryId ? <Button size="small" icon={<DatabaseOutlined/>} onClick={() => { redashMove(queryId) }} /> : null}
                </Space>
            </Header>
            {desc ? <Description ><div dangerouslySetInnerHTML={ {__html: _desc} } /></Description> : undefined}
            <Body layout={layout}>
                <Skeleton loading={loading} active avatar>
                {children}
                </Skeleton>
            </Body>
        </Container>
    )
}

FormPanel.propTypes = {
    // title: PropTypes.string,
}

FormPanel.defaultProps = {
    title: '제목',
    onClick: (id)=>{},
}

export default FormPanel
